/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import DOMPurify from 'dompurify';
import { Notification, updateNotification } from '../../../../store/Notifications';
import { TextBlock } from '../../../Atoms/Text';

export const StatusChange = ({ notification }: { notification: Notification }) => {
  const message = notification.notification_message.content;
  const messageText = `Status changed from ${message.before_val} to ${message.after_val}`;

  return (
    <div
      className="space-y-1 hover:cursor-pointer ml-9"
      onClick={() =>
        updateNotification({
          ...notification,
          is_read: true
        })
      }>
      <TextBlock
        size="sm"
        weight="normal">
        {(DOMPurify.sanitize(messageText, { RETURN_DOM: true }) as HTMLElement).innerText}
      </TextBlock>
    </div>
  );
};
